var _rect, _defs, _defs2, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSceneOneDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 960 540",
    width: 960,
    height: 540,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 960,
    height: 540,
    fill: "#000000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "43.8%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#000000",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#000000",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "100%",
    x2: "56.3%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#000000",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#000000",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(960, 540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-216 0C-208.2 -26.3 -200.4 -52.5 -191.2 -79.2C-182.1 -105.9 -171.5 -133 -152.7 -152.7C-134 -172.4 -107.2 -184.7 -80.4 -194C-53.6 -203.3 -26.8 -209.7 0 -216L0 0Z",
    fill: "#C50E6A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216 0C208.4 26.6 200.8 53.1 191.2 79.2C181.7 105.3 170.2 130.9 152 152C133.9 173.1 109.1 189.7 82.7 199.6C56.2 209.5 28.1 212.7 0 216L0 0Z",
    fill: "#C50E6A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSceneOneDark);
export default __webpack_public_path__ + "static/media/sceneOneDark.2d8044dce263e11895136a2047d72867.svg";
export { ForwardRef as ReactComponent };